/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-curly-newline */
import { useState, useEffect, useCallback } from "react";
import * as MUI from "@mui/material";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import { MenuLateralUsuario } from "../MenuLateralUsuario";

import apiUsuario from "../../../services/apiUsuario";
import { UsuarioSistema } from "../../../interface/user";

import "./tabela.css";
import { useAuth } from "../../../hooks/auth";

interface PropsParams {
  CPF: string;
}

interface IDProps {
  id_usuario: number;
}

interface Sistema {
  id_sistema: number;
  nm_sistema: string;
  PODE_ACESSAR: boolean;
}

export const AcessoSistemas: React.FC = () => {
  const [usuario, setUsuario] = useState<UsuarioSistema | null>(null);
  const { CPF } = useParams<PropsParams>();
  const [id, setId] = useState<IDProps>();
  const [sistemas, setSistemas] = useState<Sistema[] | null>(null);

  const { user } = useAuth();

  const storedToken = sessionStorage.getItem("@webSDS:token");

  useEffect(() => {
    async function findUsuario(CPF: string) {
      const response = await apiUsuario.get(`/userBy/?cpf=${CPF}`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });
      setUsuario(response.data[0]);

      setId(response.data[0].ID_USUARIO);
    }

    findUsuario(CPF);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CPF]);

  const todosOsSistemas: Sistema[] = [
    {
      id_sistema: 1,
      nm_sistema: "ALERTA (CELULAR / BIKE)",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 2,
      nm_sistema: "CIVIL",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 3,
      nm_sistema: "MANDADO",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 4,
      nm_sistema: "CARCERÁRIO",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 5,
      nm_sistema: "LISTA BOEPM OME",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 6,
      nm_sistema: "EBIC",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 7,
      nm_sistema: "BOEPM",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 8,
      nm_sistema: "VEÍCULO",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 9,
      nm_sistema: "CRIMINAL",
      PODE_ACESSAR: false,
    },
    {
      id_sistema: 10,
      nm_sistema: "LISTA BOEPM GERAL",
      PODE_ACESSAR: false,
    },
  ];

  useEffect(() => {
    const sistemasPermitidos: Sistema[] = usuario?.SISTEMAS as Sistema[];

    if (sistemasPermitidos) {
      todosOsSistemas.forEach((sis) => {
        sistemasPermitidos.forEach((sisP) => {
          if (sis.id_sistema === sisP.id_sistema) {
            // eslint-disable-next-line no-param-reassign
            sis.PODE_ACESSAR = true;
          }
        });
      });
    }

    setSistemas(todosOsSistemas);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.SISTEMAS]);

  const adicionarSistema = useCallback(
    async (idSistema: number) => {
      try {
        const response = await apiUsuario.post(
          `/systemAccess/${id}/${idSistema}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (sistemas) {
            const copiaSistema = [...sistemas];
            const sistemaAlterado = copiaSistema.find(
              (sisAlterado) => sisAlterado.id_sistema === idSistema
            );
            const index = copiaSistema.findIndex(
              (sisAlterado) => sisAlterado.id_sistema === idSistema
            );
            if (sistemaAlterado) {
              copiaSistema.splice(index, 1, {
                ...sistemaAlterado,
                PODE_ACESSAR: true,
              });
            }
            if (sistemaAlterado) {
              setSistemas(copiaSistema);
            }
          }
          toast.success(`${response.data}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2500,
          });
        }
      } catch (err: any) {
        if (err.response.status === 401) {
          toast.warning("Este usuario ja possui acesso à este sistema!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, sistemas]
  );

  const removerSistema = useCallback(
    async (idSistema: number) => {
      try {
        const response = await apiUsuario.delete(
          `/systemAccess/${id}/${idSistema}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (sistemas) {
            const copiaSistema = [...sistemas];
            const sistemaAlterado = copiaSistema.find(
              (sisAlterado) => sisAlterado.id_sistema === idSistema
            );
            const index = copiaSistema.findIndex(
              (sisAlterado) => sisAlterado.id_sistema === idSistema
            );
            if (sistemaAlterado)
              copiaSistema.splice(index, 1, {
                ...sistemaAlterado,
                PODE_ACESSAR: false,
              });
            if (sistemaAlterado) {
              setSistemas(copiaSistema);
            }
          }
          toast.success(`${response.data}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2500,
          });
        }
      } catch (err: any) {
        if (err.response.status === 401) {
          toast.warning("Este usuario ja possui acesso à este sistema!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, sistemas]
  );

  const checarLista = (sistema: Sistema) => {
    if (
      sistema.id_sistema === 6 &&
      ![
        "bombeiros",
        "ic",
        "iml",
        "pm",
        "policiacientifica",
        "policiacivil",
        "sds",
      ].includes(sistema.nm_sistema)
    )
      return false;
    if (
      sistema.id_sistema === 5 ||
      sistema.id_sistema === 7 ||
      sistema.id_sistema === 10
    ) {
      if (user?.base === "pm" || user?.tipo_acesso.id_acesso === "2") {
        return true;
      }
      return false;
    }
    return true;
  };

  return (
    <MUI.Stack flexDirection="row" width="100%" height="80vh">
      <MenuLateralUsuario />

      <MUI.Stack gap={1} px={2} pt={2} flex={1} height="75vh" overflow="auto">
        <MUI.Stack>
          <MUI.Typography variant="h5" fontWeight="bold">
            Acesso à sistemas
          </MUI.Typography>
          <MUI.Stack flexDirection="row">
            <MUI.Typography variant="body2">
              Adicione ou remova os acessos aos sistemas do usuário -
            </MUI.Typography>
            <MUI.Typography variant="body2" color="blue" fontWeight="bold">
              {usuario?.NOME}
            </MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>

        <Table className="table">
          <Thead>
            <Tr>
              <Th>NOME DO SISTEMA</Th>
              <Th>VINCULAR USUÁRIO AO SISTEMA</Th>
            </Tr>
          </Thead>
          <Tbody>
            {sistemas &&
              sistemas.map((sistema) => {
                return (
                  checarLista(sistema) && (
                    <Tr>
                      <Td>{sistema.nm_sistema}</Td>
                      <Td>
                        {sistema.PODE_ACESSAR ? (
                          <MUI.Button
                            size="small"
                            sx={{
                              backgroundColor: "#E13334",
                              color: "white",
                            }}
                            onClick={() => removerSistema(sistema.id_sistema)}
                          >
                            Remover
                          </MUI.Button>
                        ) : (
                          <MUI.Button
                            size="small"
                            sx={{
                              backgroundColor: "#46B556",
                              color: "white",
                            }}
                            onClick={() => adicionarSistema(sistema.id_sistema)}
                          >
                            Adicionar
                          </MUI.Button>
                        )}
                      </Td>
                    </Tr>
                  )
                );
              })}
          </Tbody>
        </Table>
      </MUI.Stack>
    </MUI.Stack>
  );
};
